import { IFullWidthFields } from '@/src/modules/smarty/utilities'
import { StyledFieldWrapper } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { BaseSyntheticEvent } from 'react'
import { trimStart } from 'lodash'
import { clearFormErrorForField } from '@/src/common/utilities/clearFormErrorForField'
import { inputHasError } from '@/src/common/utilities/inputHasError'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import { HalfFieldsWrapper } from '@/src/modules/checkout/StyledComponents'
import { SelectInput } from '@/src/common/components/elements/Forms/SelectWithLabel'
import { states } from '@/src/common/utilities/stateAbbreviations'
import { ValidationError } from 'yup'

const DefaultAddressForm = ({
    fullWidthFields,
    state = 'PA',
    zip,
    formErrors,
    setFormErrors,
    setState,
    setZip,
}: {
    fullWidthFields: IFullWidthFields[]
    state: string
    zip: string
    formErrors: ValidationError[]
    setState: Function
    setZip: Function
    setFormErrors: Function
}) => {
    return (
        <>
            {fullWidthFields.map((field: IFullWidthFields) => {
                const {
                    id,
                    setField,
                    value,
                    label,
                    placeholder,
                    maxWidth = 'default-max',
                    format = '',
                    type = 'text',
                    autoComplete,
                    maxLength,
                    className,
                } = field

                return (
                    <StyledFieldWrapper key={id} maxWidth={maxWidth}>
                        <TextInputWithLabel
                            id={id}
                            value={value}
                            label={value ? label : ''}
                            placeholder={placeholder ?? label}
                            type={type}
                            numFormat={format}
                            onChange={(e: BaseSyntheticEvent) => {
                                let trimmedValue = trimStart(
                                    e.currentTarget.value
                                )
                                setField(trimmedValue)
                                clearFormErrorForField({
                                    path: id,
                                    formErrors: formErrors,
                                    setFormErrors: setFormErrors,
                                })
                            }}
                            hasError={inputHasError(formErrors, id)}
                            autoComplete={autoComplete}
                            maxLength={maxLength ?? null}
                            className={className}
                        />
                        <FormErrorDisplay formErrors={formErrors} path={id} />
                    </StyledFieldWrapper>
                )
            })}
            <HalfFieldsWrapper>
                <StyledFieldWrapper maxWidth={'half-width'}>
                    <SelectInput
                        fieldWrapperVariant={'shipping-form'}
                        className={'select-input'}
                        value={state}
                        label={state ? 'State' : ''}
                        placeholder={'State'}
                        options={states}
                        onValueChange={(value: string) => {
                            setState(value)
                            clearFormErrorForField({
                                path: 'state',
                                formErrors: formErrors,
                                setFormErrors: setFormErrors,
                            })
                        }}
                    />
                    <FormErrorDisplay formErrors={formErrors} path={'state'} />
                </StyledFieldWrapper>
                <StyledFieldWrapper maxWidth={'half-width'}>
                    <TextInputWithLabel
                        id={'zip'}
                        value={zip}
                        placeholder={'Zip Code'}
                        autoComplete={'postal-code'}
                        label={zip ? 'Zip Code' : ''}
                        onChange={(e: BaseSyntheticEvent) => {
                            let trimmedValue = trimStart(e.currentTarget.value)
                            setZip(trimmedValue.toString())
                            clearFormErrorForField({
                                path: 'zip',
                                formErrors: formErrors,
                                setFormErrors: setFormErrors,
                            })
                        }}
                        numFormat={'#####'}
                        hasError={inputHasError(formErrors, 'zip')}
                    />
                    <FormErrorDisplay formErrors={formErrors} path={'zip'} />
                </StyledFieldWrapper>
            </HalfFieldsWrapper>
        </>
    )
}

export default DefaultAddressForm
